export const CommunityEndpoints = {
  getMigrationCommunities: () => 
  `${process.env.CONTENT_URL}/rest/v1/communities/admin/standalone/migration/mine`,
  putMigrationCommunity: (communityId: number, membershipSlug: string) =>
  `${process.env.CONTENT_URL}/rest/v1/communities/admin/${communityId}/migration/membership/${membershipSlug}`,
  putFollowPublicCommunity: (communityId: number) => `${process.env.BASE_URL}/rest/v1/collections/${communityId}/follower`,
  putUnfollowPublicCommunity: (communityId: number) => `${process.env.BASE_URL}/rest/v1/collections/${communityId}/unfollow`,
  getMemberships: () => `${process.env.CONTENT_URL}/rest/v1/admin/memberships/owner`
};
